module.exports = __webpack_public_path__ + "img/with-love_en.6e6a4d5.jpg";